import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import config from '../../config';
import { getIdentityProfile, processRequestToCognito } from '../../actions/login-action';

class CleverCallback extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, error: null };
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (!code) {
      this.setState({ loading: false, error: 'No code found in URL' });
      return;
    }

    // Exchange Clever code for tokens via your backend
    fetch(`${config.invokeURL}/cleverLogin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, redirectUri: config.redirectUri })
    })
      .then(res => res.json())
      .then(tokens => {
        // Ensure tokens match what processRequestToCognito expects
        const tokenPayload = {
          id_token: tokens.id_token || tokens.idToken,
          access_token: tokens.access_token || tokens.accessToken,
          firstName: tokens.firstName,
          lastName: tokens.lastName,
          email: tokens.email
        };

        // Pass tokens to Redux action to process Cognito login
        this.props.processRequestToCognito(tokenPayload)
          .then(route => {
            browserHistory.push(route);
          })
          .catch(err => {
            console.error(err);
            this.setState({ loading: false, error: 'Failed to process Cognito login' });
          });
      })
      .catch(err => {
        console.error(err);
        this.setState({ loading: false, error: 'Token exchange failed' });
      });
  }

  render() {
    if (this.state.loading) return <div>Logging in...</div>;
    if (this.state.error) return <div style={{ color: 'red' }}>Error: {this.state.error}</div>;
    return null;
  }
}

CleverCallback.propTypes = {
  processRequestToCognito: PropTypes.func.isRequired,
  getIdentityProfile: PropTypes.func.isRequired
};

function mapStateToProps(state = {}) {
  return { ...state };
}

export default connect(mapStateToProps, { processRequestToCognito, getIdentityProfile })(CleverCallback);
